import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import useReveal from "../hooks/useReveal";
import { apiGet, API_AVAILABLE } from "../lib/api";
import Seo from "../components/Seo";

export default function BlogList() {
  useReveal();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(API_AVAILABLE);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    apiGet("/blog/posts", { expectArray: true }).then((data) => {
      if (data) setPosts(data);
      setLoading(false);
    });
  }, []);

  return (
    <main data-testid="blog-list-page" className="pt-32 md:pt-40 pb-24 bg-[#F8F5EF] min-h-screen">
      <Seo
        title="Blog & Ratgeber"
        description="Fachartikel zu Immobilienfotografie, Drohnen, 3D-Touren, Virtual Staging und visueller Immobilienvermarktung in NRW."
        path="/blog"
      />
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16 md:mb-24 reveal">
          <div className="md:col-span-9">
            <div className="overline mb-6">Ratgeber · Blog</div>
            <h1 className="font-display text-5xl md:text-6xl lg:text-[72px] leading-[1.02] text-[#1A1A1A] tracking-tight">
              Wissen rund um <br />
              <span className="gold-text italic">Immobilienvermarktung</span>.
            </h1>
          </div>
          <div className="md:col-span-3 md:flex md:items-end">
            <p className="text-[15px] leading-relaxed text-[#5A5A5A] font-light">
              Fachartikel zu Immobilienfotografie, Drohnen, 3D-Touren, Virtual Staging
              und visueller Vermarktung — mit klarem Fokus auf NRW.
            </p>
          </div>
        </div>

        {loading && <p className="text-[#5A5A5A]">Lade Beiträge…</p>}
        {!loading && !posts.length && (
          <p className="text-[#5A5A5A] font-light">
            Aktuell sind noch keine Beiträge verfügbar. Schauen Sie bald wieder vorbei.
          </p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {posts.map((p, i) => (
            <Link
              to={`/blog/${p.slug}`}
              key={p.slug}
              data-testid={`blog-list-card-${p.slug}`}
              className={`group block reveal ${i % 3 === 1 ? "lg:mt-16" : i % 3 === 2 ? "lg:mt-8" : ""}`}
            >
              <div className="img-hover aspect-[4/3] overflow-hidden mb-5">
                <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.2em]">
                <span className="gold-text">{p.category}</span>
                <span className="w-4 h-px bg-[#EAE6DE]"></span>
                <span className="text-[#5A5A5A]">{p.read_time}</span>
              </div>
              <h2 className="mt-3 font-display text-2xl md:text-[26px] leading-tight text-[#1A1A1A] group-hover:text-[#FFA500] transition-colors tracking-tight">
                {p.title}
              </h2>
              <p className="mt-3 text-[14px] leading-relaxed text-[#5A5A5A] font-light line-clamp-3">
                {p.excerpt}
              </p>
              <span className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] text-[#1A1A1A]">
                Beitrag lesen
                <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:rotate-45" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
